/** @jsx jsx */
import { useMemo } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import ConfirmIcon from '@atlaskit/icon/glyph/check';
import CancelIcon from '@atlaskit/icon/glyph/cross';
import { buttonsContainerStyles, getButtonStyles } from './styles';

var Buttons = function Buttons(_ref) {
  var mode = _ref.mode,
      confirmButtonLabel = _ref.confirmButtonLabel,
      cancelButtonLabel = _ref.cancelButtonLabel,
      onMouseDown = _ref.onMouseDown,
      onCancelClick = _ref.onCancelClick;
  var buttonStyles = useMemo(function () {
    return getButtonStyles(mode);
  }, [mode]);
  return jsx("div", {
    css: buttonsContainerStyles
  }, jsx(Button, {
    "aria-label": confirmButtonLabel,
    type: "submit",
    iconBefore: jsx(ConfirmIcon, {
      label: confirmButtonLabel,
      size: "small"
    }),
    shouldFitContainer: true,
    css: buttonStyles,
    onMouseDown: onMouseDown
  }), jsx(Button, {
    "aria-label": cancelButtonLabel,
    iconBefore: jsx(CancelIcon, {
      label: cancelButtonLabel,
      size: "small"
    }),
    onClick: onCancelClick,
    shouldFitContainer: true,
    css: buttonStyles,
    onMouseDown: onMouseDown
  }));
};

export default Buttons;